export default object => ({
  id: object.id,
  name: object.name,
  email: object.email,
  password: null,
});
